import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import DefaultLayout from '../../layout/DefaultLayout';
import Loading from '../../components/Loading';
import Alert from '../../components/Alert';
import Breadcrumb from '../../components/Breadcrumbs/Breadcrumb';
import paymentService from '../../services/paymentService';
import { toCurrency } from '../../utils/formaters';

const STORAGE_KEY = 'pagoTemporal';

const CallbackPagoBoletaExito: React.FC = () => {
  const navigate = useNavigate();

  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | undefined>(undefined);
  const [codigoTransaccion, setCodigoTransaccion] = useState<string | undefined>(undefined);
  const [pagoTemporal, setPagoTemporal] = useState<any | undefined>(undefined);

  // Recuperar pago temporal desde localStorage
  useEffect(() => {
      try {      
      const pagoTemporalJson = localStorage.getItem(STORAGE_KEY);
      if (pagoTemporalJson) {
        setPagoTemporal(JSON.parse(pagoTemporalJson));
      }
    } catch (e: any) {
      setError('No se pudo recuperar el pago temporal');
    }
  }, []);

  // Confirmar el pago en backend al cargar el pago temporal
  useEffect(() => {
    const confirmar = async () => {
      if (!pagoTemporal) return;
      setLoading(true);
      setError(undefined);
        try {        
        const response = await paymentService.confirmarPago({
          tipoPago: 'MERCADOPAGO_BOLETA',
          periodo: pagoTemporal.periodo,
          concepto: pagoTemporal.concepto,
          metadata: JSON.stringify(pagoTemporal.metadata),
          monto: String(pagoTemporal.monto),
        });

        setLoading(false);
        if (response && response.success) {
          setCodigoTransaccion(response.data);
          try {
            localStorage.removeItem(STORAGE_KEY);
          } catch {
            // ignore storage errors
          }
        } else {
          setError(response?.errors?.[0] ?? 'Ocurrió un error al confirmar el pago');
        }
      } catch (ex: any) {
        setLoading(false);
        setError(ex?.message ?? 'Ocurrió un error al confirmar el pago');
      }
    };

    confirmar();
  }, [pagoTemporal]);

  const volverInicio = () => navigate('/');

  return (
    <DefaultLayout>
      <Breadcrumb pageName="Pago Boleta - Éxito" />
      <div className="p-6">
        <div className="md:max-w-3xl mx-auto bg-white md:p-6 rounded">
          {error && <Alert type="failure" message={error} />}

          {loading && <Loading statusText="Confirmando pago..." />}

          {!loading && pagoTemporal && !error && (
            <div>
              <div className="flex flex-col items-center text-center">
                <div className="bg-green-100 text-green-700 rounded-full w-20 h-20 flex items-center justify-center mb-4">
                  <svg className="w-10 h-10" viewBox="0 0 24 24" fill="none">
                    <path d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10Z" fill="currentColor" opacity="0.2" />
                    <path d="M9 12.5l2 2 4-4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                </div>
                <h2 className="text-xl font-semibold mb-2">¡Tu pago se procesó correctamente!</h2>
                <p className="text-sm text-gray-600 mb-6">
                  Hemos registrado tu transacción de manera exitosa. Podés revisar los detalles en tu cuenta.
                </p>
              </div>

              <div className="bg-gray-50 rounded p-4">
                <div className="grid grid-cols-2 gap-3">
                  <div className="text-sm text-gray-700">Período</div>
                  <div className="text-sm font-semibold text-right">{pagoTemporal.periodo}</div>

                  <div className="text-sm text-gray-700">Concepto</div>
                  <div className="text-sm font-semibold text-right">{pagoTemporal.metadata?.descripcion}</div>

                  <div className="text-sm text-gray-700">Monto pagado</div>
                  <div className="text-sm font-bold text-right">{toCurrency(pagoTemporal.monto)}</div>

                  <div className="text-sm text-gray-700">Código de Transacción</div>
                  <div className="text-sm font-bold text-right">{codigoTransaccion ?? '-'}</div>
                </div>
              </div>

              <div className="mt-8 text-center">
                <button
                  onClick={volverInicio}
                  className="px-6 py-3 rounded font-semibold text-white bg-primario-celeste-800"
                >
                  Volver al inicio
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </DefaultLayout>
  );
};

export default CallbackPagoBoletaExito;